import { gql, useMutation } from "@apollo/client";
import { Box, Button, Rating, TextField, Typography } from "@mui/material";
import { useState } from "react";
import PropTypes from 'prop-types';

const SUBMIT_REVIEW_MUTATION = gql`
  mutation submitReview($recipe_id: ID!, $rating: Float, $reviewText: String) {
    submitReview(
      recipe_id: $recipe_id
      rating: $rating
      reviewText: $reviewText
    )
  }
`;

export default function ReviewForm({ refetchParentData, recipe_id }) {
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");

  // useMutation hook for submitting the review
  const [submitReview, { loading, error }] = useMutation(
    SUBMIT_REVIEW_MUTATION,
    {
      onCompleted: () => {
        refetchParentData();
        setReviewText("");
        setRating(0);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if rating and reviewText are not empty
    if (!rating || !reviewText) {
      console.log("Rating and Review Text are mandatory");
      return;
    }

    // Submit the review mutation
    submitReview({
      variables: {
        recipe_id,
        rating,
        reviewText,
      },
    });
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 2,
        }}
      >
        Write a Review
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Rating
          name="simple-controlled"
          value={rating}
          onChange={(e, newValue) => setRating(parseFloat(newValue))}
          sx={{ my: 2 }}
        />

        <TextField
          label="Your Review"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </Button>
        {error && (
          <Typography color="error">
            An error occurred. Please try again.
          </Typography>
        )}
      </Box>
    </Box>
  );
}

ReviewForm.propTypes = {
  refetchParentData: PropTypes.func.isRequired,
  recipe_id: PropTypes.string.isRequired,
};